export const DEFAULT_ALL_SELECTS = 0;

export const GROUP_BY_OPTIONS = [
  { label: 'Estabelecimento', value: 'idEstabelecimento' },
  { label: 'Lotação', value: 'idLotacao' },
  { label: 'Função', value: 'idFuncao' },
];

export const ORDER_BY_OPTIONS = [
  { label: 'Matrícula', value: 'matricula' },
  { label: 'Nome', value: 'nome' },
];
